<template>
  <div class="fixed-container" :style="customStyle">
    <div
      class="fixed-item"
      v-if="$route.name === 'wikiList'"
      title="发稿"
      @click="handleItem('editor')"
      style="background: #0EC4FF;"
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M15.08 4.33163C15.0408 4.2936 14.9783 4.29408 14.9397 4.33271L12.2899 6.98245L17.3981 11.8287C17.7587 12.1708 17.7737 12.7404 17.4316 13.101C17.0895 13.4616 16.5199 13.4766 16.1593 13.1345L11.0167 8.25569L3.9289 15.3435C3.91015 15.3623 3.89961 15.3877 3.89961 15.4142V22C3.89961 22.0552 3.94438 22.1 3.99961 22.1H13.6694L23.4145 12.5565C23.4547 12.5171 23.4545 12.4524 23.4142 12.4132L15.08 4.33163ZM16.242 22.1L24.6739 13.8425C25.4374 13.0948 25.4343 11.8649 24.6672 11.121L16.3331 3.03941C15.5879 2.31685 14.4008 2.32598 13.6669 3.05992L2.65611 14.0707C2.29979 14.427 2.09961 14.9103 2.09961 15.4142V22C2.09961 23.0493 2.95027 23.9 3.99961 23.9H14.0366H25.0737V22.1H16.242Z"
          fill="white"
        />
      </svg>
    </div>
    <div v-if="$route.name === 'wikiHome'" class="fixed-item" @click="handleItem('editor')" title="攻略创作">
      <i class="wiki-icon wiki-icon-game-guide"></i>
    </div>
    <div v-if="$route.name === 'wikiHome'" class="fixed-item" @click="handleItem('question')" title="社区提问">
      <i class="wiki-icon wiki-icon-question"></i>
    </div>
    <div v-if="$route.name !== 'wikiDetail'" class="fixed-item" @click="handleItem('share')" title="分享">
      <i class="iconfont icon-fenxiang"></i>
    </div>
    <div class="fixed-item" v-if="hasScroll" @click="handleItem('top')" title="回到顶部">
      <i class="wiki-icon wiki-icon-top"></i>
    </div>
  </div>
</template>
<script>
import eventBus from "@/plugins/eventBus";
import Clipboard from "clipboard";
import calcMixin from "@/mixins/calcMixin";
import { mapGetters } from "vuex";

export default {
  name: "fixedShare",
  mixins: [calcMixin],
  props: {
    customStyle: {
      type: Object,
      default: () => ({})
    },
    // 从文章处传过来的文章id
    from: {
      type: String,
      default: ""
    },
    detail: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      // wiki首页文章id
      currentId: "",
      // wiki首页文章详情
      currentDetail: null,
      hasScroll: false
    };
  },
  computed: {
    ...mapGetters(["gameInfo"])
  },
  methods: {
    handleItem(type) {
      if (type === "top") {
        this.leftScrollTop();
        this.rightScrollTop();
        window.scrollTo({
          top: 0,
          behavior: "smooth"
        });
      } else if (type === "share") {
        let shareText = "";
        if (this.from === "detail" && this.detail) {
          shareText = `${this.detail.user.username}分享了文章:${this.detail.title}\r\n`;
          shareText += window.location.href + "\r\n";
          shareText += "来自GameKee";
        } else if (this.currentDetail) {
          shareText = `${this.currentDetail.user.username}分享了文章:${this.currentDetail.title}\r\n`;
          shareText +=
            `${window.location.origin}/${this.currentDetail.game.alias}/${this.currentDetail.id}.html` + "\r\n";
          shareText += "来自GameKee";
        } else {
          shareText = window.location.href;
        }
        let $div = document.createElement("div");
        $div.setAttribute("data-clipboard-text", shareText);
        $div.classList.add("page-share-copy-btn");
        document.body.appendChild($div);
        let clipboard = new Clipboard(".page-share-copy-btn");
        clipboard.on("success", e => {
          this.$message("复制成功！");
          document.body.removeChild($div);
          clipboard.destroy();
        });
        clipboard.on("error", e => {
          // 不支持复制
          this.$message("浏览器不支持自动复制,请更换其他浏览器");
          document.body.removeChild($div);
          clipboard.destroy();
        });
        $div.click();
      } else if (type === "editor") {
        this.goEdit();
      } else if (type === "question") {
        this.$emit("openQuestion");
      }
    },
    goEdit() {
      if (!this.isLoginShow("")) {
        sessionStorage.setItem("login_jump_path", `/${this.gameInfo.alias}/editor`);
        return false;
      }
      if (!this.isAuthRealName()) {
        sessionStorage.setItem("login_jump_path", `/${this.gameInfo.alias}/editor`);
        return false;
      }
      this.$router.push(`/${this.gameInfo.alias}/editor`);
    },
    handleScroll() {
      const winScrollTop = window.document.documentElement.scrollTop || window.document.body.scrollTop;
      const leftScroll = document.getElementById("leftScroll");
      const rightScroll = document.getElementById("rightScroll");
      if (winScrollTop > 0 || (leftScroll && leftScroll.scrollTop > 0) || (rightScroll && rightScroll.scrollTop > 0)) {
        this.hasScroll = true;
      } else {
        this.hasScroll = false;
      }
    }
  },
  mounted() {
    const leftScroll = document.getElementById("leftScroll");
    const rightScroll = document.getElementById("rightScroll");
    eventBus.$on("getDetail", val => {
      this.currentId = val;
    });
    eventBus.$on("setDetailInfos", val => {
      this.currentDetail = val;
    });
    eventBus.$on("setDetailBoxVisible", visible => {
      if (!visible) {
        this.currentId = "";
        this.currentDetail = null;
      }
    });
    window.addEventListener("scroll", this.handleScroll);
    if (leftScroll) {
      leftScroll.addEventListener("scroll", this.handleScroll);
    }
    if (rightScroll) {
      rightScroll.addEventListener("scroll", this.handleScroll);
    }
  },
  beforeDestroy() {
    const leftScroll = document.getElementById("leftScroll");
    const rightScroll = document.getElementById("rightScroll");
    window.removeEventListener("scroll", this.handleScroll);
    if (leftScroll) {
      leftScroll.removeEventListener("scroll", this.handleScroll);
    }
    if (rightScroll) {
      rightScroll.removeEventListener("scroll", this.handleScroll);
    }
  }
};
</script>
<style lang="less" scoped>
.fixed-container {
  position: fixed;
  display: flex;
  bottom: 130px;
  left: 50%;
  margin-left: 690px;
  flex-direction: column;
  .fixed-item {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 10px;
    width: 48px;
    height: 48px;
    color: #999;
    font-size: 24px;
    background-color: #fff;
    border-radius: 8px;
    transition: all ease 0.3s;
    cursor: pointer;
    &:last-child {
      margin-bottom: 0;
    }
  }
}
</style>
